import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Grid, SxProps, Theme } from "@mui/material";
import { useIsMobile } from "../hooks";
import ReinovaButton from "./ReinovaButton";

interface Props {
  text: string;
  buttonText: string;
  onClick: () => void;
}

const HelperBoxStyle: Record<string, SxProps<Theme>> = {
  container: (theme: Theme) => ({
    flexGrow: 1,
    textAlign: "left",
    background: theme.palette.primary.main,
    padding: "10px",
    borderRadius: "7px",
  }),
  helperText: {
    fontSize: "1.3rem",
    textAlign: "left",
  },
  helperTextMobile: {
    fontSize: "16px",
    textAlign: "center",
    marginBottom: "20px",
  },
  content: {
    padding: "40px",
    border: "1px solid white",
    borderRadius: "20px",
  },
  faqIcon: {
    img: {
      width: "20px",
      height: "auto",
    },
  },
  faqItemTitle: {
    fontSize: "22px",
  },
  faqContent: {
    paddingLeft: "30px",
    paddingRight: "30px",
    paddingTop: "15px",
  },
  faqContentText: {
    fontSize: "20px",
  },
};

const HelperBox: React.FC<Props> = ({ text, buttonText, onClick }) => {
  const { isMobile } = useIsMobile();

  return (
    <Box sx={HelperBoxStyle.container}>
      <Grid container md={12}>
        <Grid
          container
          md={8}
          sx={{
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {text.split("\\n").map((line) => (
            <Typography
              sx={
                isMobile
                  ? HelperBoxStyle.helperTextMobile
                  : HelperBoxStyle.helperText
              }
            >
              {line}
            </Typography>
          ))}
        </Grid>
        <Grid
          container
          md={4}
          sx={{
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ReinovaButton style={{ marginBottom: "0px" }} onClick={onClick}>
            {buttonText}
          </ReinovaButton>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HelperBox;
